import React from 'react';

import { marketingUrl } from '../../lib/meta';

import IdleLogo from '../../../assets/images/idle-logo.svg';

function AuthLegalCopy({ privacyUrl, termsUrl }) {
  return (
    <div className="flex justify-center pb-12">
      <p className="w-[280px] text-center text-[10px] leading-4 text-gray-500" data-app-region="none">
        By continuing on Idle, you agree to our{' '}
        <a href={termsUrl || marketingUrl('/terms')} className="text-black underline" target="_blank" rel="noreferrer" data-app-region="none">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href={privacyUrl || marketingUrl('/privacy')} className="text-black underline" target="_blank" rel="noreferrer" data-app-region="none">
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
}

export default function AuthLayout({ children, privacyUrl, termsUrl }) {
  return (
    <div className="flex min-h-dvh flex-col bg-gray-50 text-black" data-app-region="drag">
      <div className="flex justify-center pt-[59px]">
        <a href={marketingUrl('/')} data-app-region="none">
          <IdleLogo className="h-8 w-auto" />
        </a>
      </div>

      <main className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="flex w-[320px] flex-col items-center gap-12" data-app-region="none">
          {children}
        </div>
      </main>

      <AuthLegalCopy privacyUrl={privacyUrl} termsUrl={termsUrl} />
    </div>
  );
}
